import { Image, VideoLoop, SpringParallax } from '@ccg/core';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Text$1 from '../../basics/Text/Text.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import Tags$1 from '../Tags/Tags.js';
import StyledCoverStage from './CoverStage.style.js';

const CoverStage = ({
  className,
  breadcrumbLink,
  image,
  fixedImage,
  client,
  headline,
  subline,
  excerpt,
  video,
  loop,
  tags
}) => /*#__PURE__*/React$1.createElement(StyledCoverStage, {
  className: className,
  $fixedImage: fixedImage
}, image || video ? /*#__PURE__*/React$1.createElement("div", {
  className: "coverStage__media-wrapper"
}, image && !video ? /*#__PURE__*/React$1.createElement(Image, _extends({
  className: "coverStage__media"
}, image, {
  lazy: true
})) : null, video ? /*#__PURE__*/React$1.createElement(VideoLoop, {
  className: "coverStage__media",
  src: video.url,
  loop: loop,
  autoPlay: true
}) : null) : null, /*#__PURE__*/React$1.createElement(SpringParallax, null, /*#__PURE__*/React$1.createElement(Grid$1, {
  className: "coverStage__intro"
}, breadcrumbLink && /*#__PURE__*/React$1.createElement("div", {
  className: "coverStage__breadcrumbLink"
}, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, breadcrumbLink, {
  icon: "arrowLeft",
  transform: "uppercase"
}), breadcrumbLink.label)), /*#__PURE__*/React$1.createElement(Typography$1, {
  as: "span",
  variant: "hero",
  className: "coverStage__client"
}, client)), /*#__PURE__*/React$1.createElement(Grid$1, null, /*#__PURE__*/React$1.createElement("div", {
  className: "coverStage__headlines"
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  variant: "subheadline",
  as: "h1",
  className: "coverStage__headline"
}, headline), tags && tags.length > 0 && /*#__PURE__*/React$1.createElement(Tags$1, {
  className: "coverStage__tags",
  tags: tags,
  horizontal: true
}), subline && /*#__PURE__*/React$1.createElement(Typography$1, {
  variant: "subline",
  hasAccent: !tags || tags.length <= 0
}, subline)), /*#__PURE__*/React$1.createElement(Text$1, {
  content: excerpt,
  hasAccent: true,
  className: "coverStage__excerpt"
}))));

CoverStage.propTypes = {
  className: PropTypes$1.string,
  breadcrumbLink: PropTypes$1.shape(),
  image: PropTypes$1.shape({
    width: PropTypes$1.string,
    height: PropTypes$1.string,
    url: PropTypes$1.string,
    alt: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    src: PropTypes$1.string
  }),
  fixedImage: PropTypes$1.bool,
  video: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  loop: PropTypes$1.bool,
  client: PropTypes$1.string.isRequired,
  headline: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string,
  excerpt: PropTypes$1.string.isRequired,
  tags: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string,
    id: PropTypes$1.number
  }))
};
CoverStage.defaultProps = {
  className: '',
  breadcrumbLink: null,
  image: null,
  fixedImage: false,
  video: null,
  loop: true,
  subline: null,
  tags: []
};

export default CoverStage;
